import { render, staticRenderFns } from "./primary-module-pane.vue?vue&type=template&id=ca707f18&"
import script from "./primary-module-pane.vue?vue&type=script&lang=js&"
export * from "./primary-module-pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports